// extracted by mini-css-extract-plugin
export var answer = "QuestionAndAnswer-module--answer--dfe46";
export var arrow = "QuestionAndAnswer-module--arrow--618bc";
export var devProcessImage = "QuestionAndAnswer-module--dev-process-image--ea5db";
export var expand = "QuestionAndAnswer-module--expand--6cbcd";
export var question = "QuestionAndAnswer-module--question--66a29";
export var questionBox = "QuestionAndAnswer-module--question-box--2bd30";
export var questionContent = "QuestionAndAnswer-module--question-content--db46d";
export var technologies = "QuestionAndAnswer-module--technologies--56a3c";
export var underline = "QuestionAndAnswer-module--underline--43fbd";